"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mint = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const constants_1 = require("./constants");
const mint_1 = require("./generated/instructions/mint");
const guards_1 = require("./guards");
const hooked_1 = require("./hooked");
function mint(context, input) {
    const { mintArgs = {}, group = (0, umi_1.none)(), ...rest } = input;
    const program = context.programs.get('mplCandyGuard');
    const candyMachine = (0, umi_1.publicKey)(input.candyMachine, false);
    const mintContext = {
        minter: input.payer ?? context.payer,
        payer: input.payer ?? context.payer,
        mint: (0, umi_1.publicKey)(input.nftMint, false),
        candyMachine,
        candyGuard: (0, umi_1.publicKey)(input.candyGuard ?? (0, hooked_1.findCandyGuardPda)(context, { base: candyMachine }), false),
    };
    const { data, remainingAccounts } = (0, guards_1.parseMintArgs)(context, program, mintContext, mintArgs);
    const ix = (0, mint_1.mint)(context, { ...rest, mintArgs: data, group }).items[0];
    const [keys, signers] = (0, guards_1.parseGuardRemainingAccounts)(remainingAccounts);
    ix.instruction.keys.push(...keys);
    ix.signers.push(...signers);
    ix.bytesCreatedOnChain =
        constants_1.METADATA_SIZE + constants_1.MASTER_EDITION_SIZE + 2 * umi_1.ACCOUNT_HEADER_SIZE;
    return (0, umi_1.transactionBuilder)([ix]);
}
exports.mint = mint;
//# sourceMappingURL=mint.js.map